import { takeUntil } from 'rxjs';
import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

/**
 * httpHandler
 */
import { SessionOrchestratorService, SessionOrchestratorUtils } from '../../../services/session-orchestrator';

/**
 * Session HTTP Abort Interceptor
 * 
 * @function sessionHttpAbortInterceptor
 * @description Placeholder interceptor for session-based HTTP request abortion.
 * Currently passes requests through without modification. Intended for future
 * implementation of session timeout handling and request cancellation.
 * 
 * @param {HttpRequest<any>} req - The outgoing HTTP request
 * @param {HttpHandlerFn} next - The next interceptor in the chain
 * @returns {Observable<HttpEvent<any>>} The HTTP response (currently unmodified)
 * 
 * @example
 * ```typescript
 * // Currently passes requests through without modification
 * // Future implementation will handle session timeouts
 * this.http.get('/api/users').subscribe();
 * ```
 * 
 * @since 1.0.0
 * @author SADIN Development Team
 */
export const sessionHttpAbortInterceptor: HttpInterceptorFn = (req, next) => {

  // Check if request has bypass abort context
  const _isHasBypassAbort = SessionOrchestratorUtils.isHasBypassAbort(req);

  // If request has bypass abort context, return next request
  if (_isHasBypassAbort) {
    return next(req);
  }
  
  // Inject Session Orchestrator Service
  const _sessionOrchestratorService = inject(SessionOrchestratorService);

  // Return next request and pipe to global abort subject
  return next(req).pipe(
    takeUntil(_sessionOrchestratorService.global$)
  );
  
};
